import { ConfigProvider } from '@bc/react-config';
import { LoadingIcon } from 'bc-front-sagacomponents';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import ReactPWAInstallProvider from './components/InstallApp';
import ReduxProvider from './components/ReduxProvider';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { initializeKeycloak } from './services/Authentification/authentification';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ReactQueryProvider from './components/ReactQueryProvider';

const handleConfigLoaded = () => {
  initializeKeycloak();
  if (process.env.NODE_ENV === 'production') {
    // Sentry.init({
    //   dsn: getSentryUrl(),
    //   release: process.env.REACT_APP_VERSION,
    //   environment: getSentryEnvironment(),
    //   integrations: [new Integrations.BrowserTracing()],
    //   // We recommend adjusting this value in production, or using tracesSampler
    //   // for finer control
    //   // tracesSampleRate: 1.0,
    // });
  }
};

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider onLoad={handleConfigLoaded} loading={<LoadingIcon />} url="conf/configv2.json">
      <ReduxProvider>
        {/* <MuiThemeProvider theme={theme}> */}

        <ErrorBoundary>
          <ReactQueryProvider>
            <ReactPWAInstallProvider enableLogging>
              <App />
            </ReactPWAInstallProvider>
          </ReactQueryProvider>
        </ErrorBoundary>
        {/* </MuiThemeProvider> */}
      </ReduxProvider>
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
